import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import { __decorate } from "tslib";
import { Options, Vue } from 'vue-class-component';
import store from '@/store';
import debounce from 'lodash/debounce';
import { CHECK_ALL_SPEACH_FROM_BACK, CHECK_ALL_SPEACH_NOT_CHECKED, CHECK_SPEACH, COPY_SPEACH_SEARCH_FILTERS, EMPTY_SPEACH_LIST, GET_SPEACH_FROM_SPEACH_ID, REFRESH_CHECKED_SPEACH_TO_SHOW, REFRESH_COUR_IN_CHECKED_LIST, SPEACH_IDS_LIST, SPEACH_LIST, UNCHECK_ALL_SPEACH_FROM_BACK, UNCHECK_ALL_SPEACH_IN_SEARCH_LIST, UNCHECK_SPEACH } from '@/store/actions/speach';
import { v4 as uuidv4 } from 'uuid';
import SpeachTable from '@/components/platform/copySpeach/SpeachTable.vue';
import InfiniteLoading from 'vue-infinite-loading';
import Banner from "@/components/banner/Banner.vue";
var ChooseSpeach = /*#__PURE__*/function (_Vue) {
  function ChooseSpeach() {
    var _this;
    _classCallCheck(this, ChooseSpeach);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ChooseSpeach, [].concat(args));
    _defineProperty(_this, "checkAllMessage", false);
    _defineProperty(_this, "uncheckAllMessage", false);
    _defineProperty(_this, "infiniteLoaderID", uuidv4());
    _defineProperty(_this, "loading", false);
    _defineProperty(_this, "debounceInfinite", debounce(function (state) {
      if (_this.totalNumber <= _this.listSpeach.length) {
        state.complete();
        state.loaded();
      } else {
        _this.infiniteHandler(state);
      }
    }, 250));
    return _this;
  }
  _inherits(ChooseSpeach, _Vue);
  return _createClass(ChooseSpeach, [{
    key: "listSpeach",
    get:
    // -- Computed variables
    function get() {
      return store.getters.listSpeach;
    }
  }, {
    key: "listCheckedSpeach",
    get: function get() {
      return store.getters.listCheckedSpeach;
    }
  }, {
    key: "listCheckedSpeachSearchList",
    get: function get() {
      return store.getters.listCheckedSpeachSearchList;
    }
  }, {
    key: "currentPage",
    get: function get() {
      return store.getters.currentPageSpeach;
    }
  }, {
    key: "totalNumber",
    get: function get() {
      return store.getters.totalNumberSpeach;
    }
  }, {
    key: "sourcePlatform",
    get: function get() {
      return store.getters.sourcePlatform;
    }
  }, {
    key: "sourceCategories",
    get: function get() {
      return store.getters.categories(this.sourcePlatform.platformID);
    }
  }, {
    key: "searchFilters",
    get: function get() {
      return store.getters.copySpeachSearchFilters;
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var _this$listSpeach,
        _this2 = this;
      if (!((_this$listSpeach = this.listSpeach) !== null && _this$listSpeach !== void 0 && _this$listSpeach.length)) {
        this.loading = true;
        this.searchSpeach().then(function () {
          return _this2.loading = false;
        });
      }
    }
  }, {
    key: "filterTitle",
    value: function () {
      var _filterTitle = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(titleFilter) {
        var _this$searchFilters, _this$searchFilters2;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.filter(titleFilter, (_this$searchFilters = this.searchFilters) === null || _this$searchFilters === void 0 ? void 0 : _this$searchFilters.author, (_this$searchFilters2 = this.searchFilters) === null || _this$searchFilters2 === void 0 ? void 0 : _this$searchFilters2.category);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function filterTitle(_x) {
        return _filterTitle.apply(this, arguments);
      }
      return filterTitle;
    }()
  }, {
    key: "filterAuthor",
    value: function () {
      var _filterAuthor = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(authorFilter) {
        var _this$searchFilters3, _this$searchFilters4;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.filter((_this$searchFilters3 = this.searchFilters) === null || _this$searchFilters3 === void 0 ? void 0 : _this$searchFilters3.title, authorFilter, (_this$searchFilters4 = this.searchFilters) === null || _this$searchFilters4 === void 0 ? void 0 : _this$searchFilters4.category);
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function filterAuthor(_x2) {
        return _filterAuthor.apply(this, arguments);
      }
      return filterAuthor;
    }()
  }, {
    key: "filterCategory",
    value: function () {
      var _filterCategory = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(categoryFilter) {
        var _this$sourceCategorie, _this$searchFilters5, _this$searchFilters6;
        var categoryFilterId, category;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              categoryFilterId = categoryFilter === null || categoryFilter === void 0 ? void 0 : categoryFilter.id;
              category = (_this$sourceCategorie = this.sourceCategories) === null || _this$sourceCategorie === void 0 ? void 0 : _this$sourceCategorie.find(function (c) {
                return c.id === categoryFilterId;
              });
              _context3.next = 4;
              return this.filter((_this$searchFilters5 = this.searchFilters) === null || _this$searchFilters5 === void 0 ? void 0 : _this$searchFilters5.title, (_this$searchFilters6 = this.searchFilters) === null || _this$searchFilters6 === void 0 ? void 0 : _this$searchFilters6.author, category);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function filterCategory(_x3) {
        return _filterCategory.apply(this, arguments);
      }
      return filterCategory;
    }()
  }, {
    key: "filter",
    value: function () {
      var _filter = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(filteredTitle, filteredAuthor, filteredCategory) {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return store.dispatch(COPY_SPEACH_SEARCH_FILTERS, {
                title: filteredTitle,
                author: filteredAuthor,
                category: filteredCategory
              });
            case 2:
              _context4.next = 4;
              return this.searchSpeach();
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function filter(_x4, _x5, _x6) {
        return _filter.apply(this, arguments);
      }
      return filter;
    }()
  }, {
    key: "check",
    value: function () {
      var _check = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(checkedList, row) {
        var indexOfRow;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!row) {
                _context5.next = 13;
                break;
              }
              this.checkAllMessage = false;
              this.uncheckAllMessage = false;
              indexOfRow = checkedList.findIndex(function (c) {
                return c.speachID === row.speachID;
              });
              if (!(indexOfRow != -1)) {
                _context5.next = 9;
                break;
              }
              _context5.next = 7;
              return store.dispatch(CHECK_SPEACH, row);
            case 7:
              _context5.next = 11;
              break;
            case 9:
              _context5.next = 11;
              return store.dispatch(UNCHECK_SPEACH, row);
            case 11:
              _context5.next = 13;
              return store.dispatch(REFRESH_CHECKED_SPEACH_TO_SHOW);
            case 13:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function check(_x7, _x8) {
        return _check.apply(this, arguments);
      }
      return check;
    }()
  }, {
    key: "allCheck",
    value: function () {
      var _allCheck = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(checkedList) {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              this.uncheckAllMessage = false;
              if (!((checkedList === null || checkedList === void 0 ? void 0 : checkedList.length) > 0)) {
                _context6.next = 7;
                break;
              }
              _context6.next = 4;
              return store.dispatch(CHECK_ALL_SPEACH_NOT_CHECKED, checkedList);
            case 4:
              this.checkAllMessage = true;
              _context6.next = 10;
              break;
            case 7:
              this.checkAllMessage = false;
              _context6.next = 10;
              return store.dispatch(UNCHECK_ALL_SPEACH_IN_SEARCH_LIST);
            case 10:
              _context6.next = 12;
              return store.dispatch(REFRESH_CHECKED_SPEACH_TO_SHOW);
            case 12:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function allCheck(_x9) {
        return _allCheck.apply(this, arguments);
      }
      return allCheck;
    }()
  }, {
    key: "selectAllFromBack",
    value: function () {
      var _selectAllFromBack = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _this$searchFilters7, _this$searchFilters8, _this$searchFilters9;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              this.checkAllMessage = false;
              this.uncheckAllMessage = true;
              _context7.next = 4;
              return store.dispatch(SPEACH_IDS_LIST, {
                platformID: this.sourcePlatform.platformID,
                title: (_this$searchFilters7 = this.searchFilters) === null || _this$searchFilters7 === void 0 ? void 0 : _this$searchFilters7.title,
                author: (_this$searchFilters8 = this.searchFilters) === null || _this$searchFilters8 === void 0 ? void 0 : _this$searchFilters8.author,
                categoryId: (_this$searchFilters9 = this.searchFilters) === null || _this$searchFilters9 === void 0 || (_this$searchFilters9 = _this$searchFilters9.category) === null || _this$searchFilters9 === void 0 ? void 0 : _this$searchFilters9.id
              });
            case 4:
              _context7.next = 6;
              return store.dispatch(CHECK_ALL_SPEACH_FROM_BACK);
            case 6:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function selectAllFromBack() {
        return _selectAllFromBack.apply(this, arguments);
      }
      return selectAllFromBack;
    }()
  }, {
    key: "clearAllFromBack",
    value: function () {
      var _clearAllFromBack = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              this.checkAllMessage = false;
              this.uncheckAllMessage = false;
              _context8.next = 4;
              return store.dispatch(UNCHECK_ALL_SPEACH_FROM_BACK);
            case 4:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function clearAllFromBack() {
        return _clearAllFromBack.apply(this, arguments);
      }
      return clearAllFromBack;
    }()
  }, {
    key: "checkFromSelectedList",
    value: function () {
      var _checkFromSelectedList = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9(checkedList, row) {
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return this.check(checkedList, row);
            case 2:
              _context9.next = 4;
              return store.dispatch(REFRESH_CHECKED_SPEACH_TO_SHOW);
            case 4:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function checkFromSelectedList(_x10, _x11) {
        return _checkFromSelectedList.apply(this, arguments);
      }
      return checkFromSelectedList;
    }()
  }, {
    key: "refreshCourAndAddToListChecked",
    value: function () {
      var _refreshCourAndAddToListChecked = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10(row) {
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              store.dispatch(GET_SPEACH_FROM_SPEACH_ID, {
                platformID: this.sourcePlatform.platformID,
                speachID: row.speachID
              }).then(function (cour) {
                if (cour) {
                  store.dispatch(REFRESH_COUR_IN_CHECKED_LIST, cour);
                }
              });
            case 1:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function refreshCourAndAddToListChecked(_x12) {
        return _refreshCourAndAddToListChecked.apply(this, arguments);
      }
      return refreshCourAndAddToListChecked;
    }()
  }, {
    key: "searchSpeach",
    value: function () {
      var _searchSpeach = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var page,
          append,
          _this$searchFilters10,
          _this$searchFilters11,
          _this$searchFilters12,
          _args11 = arguments;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              page = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : 1;
              append = _args11.length > 1 && _args11[1] !== undefined ? _args11[1] : false;
              this.checkAllMessage = false;
              this.uncheckAllMessage = false;
              if (!this.sourcePlatform) {
                _context11.next = 9;
                break;
              }
              _context11.next = 7;
              return store.dispatch(SPEACH_LIST, {
                platformID: this.sourcePlatform.platformID,
                title: (_this$searchFilters10 = this.searchFilters) === null || _this$searchFilters10 === void 0 ? void 0 : _this$searchFilters10.title,
                author: (_this$searchFilters11 = this.searchFilters) === null || _this$searchFilters11 === void 0 ? void 0 : _this$searchFilters11.author,
                categoryId: (_this$searchFilters12 = this.searchFilters) === null || _this$searchFilters12 === void 0 || (_this$searchFilters12 = _this$searchFilters12.category) === null || _this$searchFilters12 === void 0 ? void 0 : _this$searchFilters12.id,
                page: page,
                append: append
              });
            case 7:
              _context11.next = 11;
              break;
            case 9:
              _context11.next = 11;
              return store.dispatch(EMPTY_SPEACH_LIST);
            case 11:
              //if we don't append the search, it is a new one, so we have to reset the infinite handler
              if (!append) {
                this.resetInfiniteHandler();
              }
              _context11.next = 14;
              return store.dispatch(REFRESH_CHECKED_SPEACH_TO_SHOW);
            case 14:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function searchSpeach() {
        return _searchSpeach.apply(this, arguments);
      }
      return searchSpeach;
    }() //We need to reset the infinite handler when we perform a new search.
  }, {
    key: "resetInfiniteHandler",
    value: function resetInfiniteHandler() {
      //The easiest way to reset the infinite handler is to change its id
      this.infiniteLoaderID = uuidv4();
    }
  }, {
    key: "infiniteHandler",
    value: function infiniteHandler(state) {
      var _this3 = this;
      this.searchSpeach(this.currentPage + 1, true).then(function () {
        if (_this3.totalNumber <= _this3.listSpeach.length) {
          state.complete();
        }
        state.loaded();
      }).catch(function () {
        state.complete();
      });
    }
  }, {
    key: "goToPlatform",
    value: function goToPlatform(url) {
      window.open(url, '_blank');
    }
  }]);
}(Vue);
ChooseSpeach = __decorate([Options({
  components: {
    SpeachTable: SpeachTable,
    InfiniteLoading: InfiniteLoading,
    Banner: Banner
  }
})], ChooseSpeach);
export default ChooseSpeach;